import { render, staticRenderFns } from "./SingleMatchInfo.vue?vue&type=template&id=79b7acfe&scoped=true&"
import script from "./SingleMatchInfo.vue?vue&type=script&lang=js&"
export * from "./SingleMatchInfo.vue?vue&type=script&lang=js&"
import style0 from "./SingleMatchInfo.vue?vue&type=style&index=0&id=79b7acfe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b7acfe",
  null
  
)

export default component.exports